module.exports = __webpack_public_path__ + "img/logo.099ba423.svg";